module.exports = __webpack_public_path__ + "static/media/video-meeting.3ae8e40f.png";